var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEyeDropper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1172 8.18465L11.2988 7.99129C11.6211 7.65731 11.627 7.26473 11.293 6.93075L11.1289 6.76668C12.0605 5.94637 13.0684 5.86434 13.7246 5.20223C14.6328 4.28231 14.3984 2.95809 13.7012 2.25497C13.0098 1.55184 11.6855 1.32918 10.7539 2.23153C10.0859 2.88192 10.0098 3.89559 9.18945 4.82723L9.03125 4.66317C8.69727 4.32333 8.29883 4.33504 7.96484 4.65731L7.77148 4.83895C7.37891 5.20809 7.4375 5.55965 7.78906 5.90536L8.02344 6.14559L3.73437 10.4347C1.84766 12.3214 2.59766 12.2862 1.67773 13.5636L2.28125 14.1964C3.51758 13.2765 3.58789 14.1085 5.49219 12.2159L9.81055 7.92684L10.0508 8.16708C10.4023 8.51278 10.7422 8.57137 11.1172 8.18465ZM6.25977 9.72567C6.06641 9.50887 6.10742 9.30965 6.31836 9.09286L8.63867 6.75497L9.21289 7.32919L6.875 9.67294C6.68164 9.86044 6.44141 9.91903 6.25977 9.72567Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeDropper);
export default __webpack_public_path__ + "static/media/icon-eye-dropper.c22c42e2169711479185df775af4662c.svg";
export { ForwardRef as ReactComponent };